/* Body · videos do produto em tela cheia, estilo Reels (snippet body-videos).
   Abre ao tocar num card [data-body-reel] dentro de [data-body-reels] (dados em [data-body-reels-data]).
   Os videos rolam para cima (scroll-snap vertical). So o video visivel baixa e toca; o proximo
   pre-carrega os metadados. HLS no Safari (qualidade adaptativa), mp4 de ate 720px nos demais.
   O botao de compra fecha o player e aciona o "Comprar agora" da pagina: usa o sabor escolhido
   e o mesmo fluxo de checkout. O botao voltar do celular fecha o player.
   Adaptado de assets/vpr-reels.js do tema da VPR. */
(() => {
  if (window.__bodyReels) return;
  window.__bodyReels = true;

  const ICON = {
    close: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    on: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 9v6h4l5 4V5L8 9z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    off: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 9v6h4l5 4V5L8 9z" fill="currentColor"/><path d="M17 9.5l5 5M22 9.5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="30" height="30"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>',
    up: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    down: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  // HLS so no Safari (iPhone, iPad, Mac), onde o suporte e nativo e confiavel. O Chrome
  // novo responde "maybe" ao canPlayType de HLS mas nao carrega o video; la vai mp4.
  const ua = navigator.userAgent;
  const isAppleSafari = /Apple/.test(navigator.vendor) && !/CriOS|FxiOS|EdgiOS/.test(ua) || /iPhone|iPad|iPod/.test(ua);
  const canHls = isAppleSafari && document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';

  let dlg, track, io, data, muted = false, current = -1;
  let pushed = false, closingFromBack = false;

  // Formulario e botao de compra da pagina (o mesmo que o cliente usaria fora do video).
  // Precisa ser o "Comprar agora" (data-buy-now): o form tem outros botoes de submit,
  // como o de adicionar ao mini carrinho, que vem antes no HTML.
  const productForm = () => document.querySelector('form[action="/cart/add"][data-product-form]') || document.querySelector('form[action="/cart/add"]');
  const pageBuyButton = () => {
    const f = productForm();
    return f?.querySelector('[data-buy-now]') || f?.querySelector('.buttonBuyNow') || f?.querySelector('[type="submit"]');
  };
  const selectedVariant = () => {
    const id = productForm()?.querySelector('[name="id"]')?.value;
    return (id && data.variants[id]) ? data.variants[id] : data.variants[data.variant];
  };

  function build(d) {
    data = d;
    dlg?.remove();
    dlg = document.createElement('dialog');
    dlg.className = 'body-reels';
    dlg.setAttribute('aria-label', 'Vídeos de ' + d.product.title);
    dlg.innerHTML = `
      <div class="body-reels__stage">
        <div class="body-reels__track">${d.items.map((it, i) => `
          <section class="body-reels__slide" data-i="${i}" aria-label="Vídeo ${i + 1} de ${d.items.length}">
            <video class="body-reels__video" playsinline loop preload="none" poster="${esc(it.poster)}" aria-label="${esc(it.alt)}"></video>
            <span class="body-reels__paused" aria-hidden="true">${ICON.play}</span>
            <div class="body-reels__bar"><i></i></div>
            <div class="body-reels__card">
              ${(it.imagem || d.product.image) ? `<img src="${esc(it.imagem || d.product.image)}" alt="" width="52" height="52" loading="lazy">` : ''}
              <div class="body-reels__info">
                <span class="body-reels__name">${esc(it.titulo || d.product.title)}</span>
                <span class="body-reels__variant" data-body-reels-variant></span>
                <span class="body-reels__price" data-body-reels-price></span>
              </div>
              <button type="button" class="body-reels__buy" data-body-reels-buy></button>
            </div>
          </section>`).join('')}
        </div>
        <div class="body-reels__top">
          <span class="body-reels__count"></span>
          <button type="button" class="body-reels__btn" data-body-reels-mute aria-label="Tirar o som">${ICON.on}</button>
          <button type="button" class="body-reels__btn" data-body-reels-close aria-label="Fechar">${ICON.close}</button>
        </div>
        <div class="body-reels__nav">
          <button type="button" class="body-reels__btn" data-body-reels-go="-1" aria-label="Vídeo anterior">${ICON.up}</button>
          <button type="button" class="body-reels__btn" data-body-reels-go="1" aria-label="Próximo vídeo">${ICON.down}</button>
        </div>
      </div>`;
    document.body.appendChild(dlg);
    track = dlg.querySelector('.body-reels__track');

    io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) activate(Number(e.target.dataset.i)); });
    }, { root: track, threshold: 0.6 });
    dlg.querySelectorAll('.body-reels__slide').forEach((s) => io.observe(s));

    dlg.addEventListener('click', onClick);
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); go(e.key === 'ArrowDown' ? 1 : -1); }
    });
  }

  // Preco, sabor e botao refletem a variante escolhida na pagina no momento em que o player abre.
  function syncVariant() {
    // Stories da home: cada vídeo é de um produto; preço do próprio item e botão "Ver produto".
    if (data.modo === 'stories') {
      dlg.querySelectorAll('.body-reels__slide').forEach((s, i) => {
        const it = data.items[i] || {};
        s.querySelector('[data-body-reels-variant]').hidden = true;
        s.querySelector('[data-body-reels-price]').innerHTML = it.preco ? `<b>${esc(it.preco)}</b>` : '';
        const b = s.querySelector('[data-body-reels-buy]');
        b.disabled = false;
        b.textContent = data.cta || 'Ver produto';
      });
      return;
    }
    const v = selectedVariant();
    const show = v && v.title !== 'Default Title' ? v.title : '';
    dlg.querySelectorAll('[data-body-reels-variant]').forEach((el) => { el.textContent = show; el.hidden = !show; });
    dlg.querySelectorAll('[data-body-reels-price]').forEach((el) => {
      el.innerHTML = v ? `${v.compare ? `<s>${esc(v.compare)}</s>` : ''}<b>${esc(v.price)}</b>` : '';
    });
    const ok = !!(v && v.available);
    dlg.querySelectorAll('[data-body-reels-buy]').forEach((b) => {
      b.disabled = !ok;
      b.textContent = ok ? (data.cta || 'Comprar agora') : 'Esgotado';
    });
  }

  function load(i) {
    const v = track.children[i]?.querySelector('video');
    if (!v || v.dataset.loaded) return v;
    const it = data.items[i];
    const usaHls = canHls && it.hls;
    v.src = usaHls ? it.hls : it.mp4;
    v.dataset.loaded = '1';
    if (usaHls) {
      // Rede de seguranca: se o HLS der erro ou nao comecar a carregar, troca para mp4.
      const paraMp4 = () => {
        if (v.dataset.fallback || !it.mp4) return;
        v.dataset.fallback = '1';
        const tocava = !v.paused;
        v.src = it.mp4;
        if (tocava) play(v);
      };
      v.addEventListener('error', paraMp4, { once: true });
      v.addEventListener('play', () => setTimeout(() => { if (v.readyState === 0) paraMp4(); }, 4000), { once: true });
    }
    v.addEventListener('timeupdate', () => {
      const bar = v.parentNode.querySelector('.body-reels__bar i');
      if (v.duration) bar.style.transform = `scaleX(${v.currentTime / v.duration})`;
    });
    return v;
  }

  function play(v) {
    if (!v) return;
    v.muted = muted;
    v.play().catch(() => {
      // o navegador bloqueou o som sem toque direto: toca mudo e mostra o botao de som
      if (!v.muted) { setMuted(true); v.play().catch(() => {}); }
    });
    v.parentNode.classList.remove('is-paused');
  }

  function activate(i) {
    if (i === current) return;
    current = i;
    [...track.children].forEach((s, j) => {
      const v = s.querySelector('video');
      if (j !== i && v) v.pause();
    });
    play(load(i));
    const next = load(i + 1);
    if (next) next.preload = 'metadata';
    dlg.querySelector('.body-reels__count').textContent = `${i + 1} / ${data.items.length}`;
    dlg.querySelector('[data-body-reels-go="-1"]').disabled = i === 0;
    dlg.querySelector('[data-body-reels-go="1"]').disabled = i === data.items.length - 1;
  }

  function go(dir) {
    const t = track.children[current + dir];
    if (t) t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function setMuted(m) {
    muted = m;
    const b = dlg.querySelector('[data-body-reels-mute]');
    b.innerHTML = m ? ICON.off : ICON.on;
    b.setAttribute('aria-label', m ? 'Ativar o som' : 'Tirar o som');
    track.querySelectorAll('video').forEach((v) => { v.muted = m; });
  }

  async function buy() {
    // Stories da home: o botão leva ao produto do vídeo.
    const item = data.items[current];
    if (item && item.url) { window.location.href = item.url; return; }
    // Fecha o player e espera o history.back() do onClose terminar antes de comprar,
    // para o voltar nao competir com o redirecionamento do checkout.
    const voltou = new Promise((ok) => {
      const fim = () => { window.removeEventListener('popstate', fim); ok(); };
      window.addEventListener('popstate', fim);
      setTimeout(fim, 400);
    });
    dlg.close();
    await voltou;
    const btn = pageBuyButton();
    if (btn) { btn.click(); return; }
    // Sem botao na pagina (nao deveria acontecer): adiciona a variante escolhida e vai ao carrinho.
    const id = productForm()?.querySelector('[name="id"]')?.value || data.variant;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      if (!r.ok) throw new Error(r.status);
    } finally {
      window.location.href = '/cart';
    }
  }

  function onClick(e) {
    if (e.target === dlg || e.target.closest('[data-body-reels-close]')) return dlg.close();
    if (e.target.closest('[data-body-reels-mute]')) return setMuted(!muted);
    const g = e.target.closest('[data-body-reels-go]');
    if (g) return go(Number(g.dataset.bodyReelsGo));
    if (e.target.closest('[data-body-reels-buy]')) return buy();
    const v = e.target.closest('.body-reels__slide')?.querySelector('video');
    if (v && e.target.closest('video, .body-reels__paused')) {
      if (v.paused) play(v); else { v.pause(); v.parentNode.classList.add('is-paused'); }
    }
  }

  // A entrada no historico e controlada por flag, e nao por history.state: o tema
  // reescreve o state com replaceState ao trocar de variante.
  function onClose() {
    track.querySelectorAll('video').forEach((v) => v.pause());
    document.documentElement.classList.remove('body-reels-open');
    current = -1;
    if (pushed && !closingFromBack) history.back();
    pushed = false;
    closingFromBack = false;
  }

  window.addEventListener('popstate', () => {
    if (dlg?.open) { closingFromBack = true; dlg.close(); }
  });

  document.addEventListener('click', (e) => {
    // setas da faixa de capas (desktop)
    const arrow = e.target.closest('[data-body-reels-scroll]');
    if (arrow) {
      const list = arrow.closest('[data-body-reels]')?.querySelector('[data-body-reels-list]');
      const card = list?.firstElementChild;
      if (list && card) list.scrollBy({ left: Number(arrow.dataset.bodyReelsScroll) * (card.offsetWidth + 10), behavior: 'smooth' });
      return;
    }

    const card = e.target.closest('[data-body-reel]');
    if (!card) return;
    const root = card.closest('[data-body-reels]');
    const src = root?.querySelector('[data-body-reels-data]');
    if (!src) return;
    e.preventDefault();
    abrir(card, root, src);
  });

  // Na home e na landing o CSS do player não vem na página (não trava a abertura): baixa no
  // primeiro toque, pelo endereço em data-body-reels-css, e o player abre quando ele chega
  // (no máximo 1,5 s; o toque continua valendo para tocar com som).
  const cssDoPlayer = (root) => {
    const url = root.dataset.bodyReelsCss;
    if (!url) return Promise.resolve();
    let link = document.querySelector('link[data-body-reels-css]');
    if (!link) {
      link = Object.assign(document.createElement('link'), { rel: 'stylesheet', href: url });
      link.dataset.bodyReelsCss = '';
      document.head.append(link);
    } else if (link.sheet) return Promise.resolve();
    return new Promise((ok) => { link.addEventListener('load', ok, { once: true }); link.addEventListener('error', ok, { once: true }); setTimeout(ok, 1500); });
  };

  async function abrir(card, root, src) {
    await cssDoPlayer(root);
    if (dlg?.__root !== root) {
      build(JSON.parse(src.textContent));
      dlg.__root = root;
    }
    syncVariant();
    const i = Number(card.dataset.bodyReel) || 0;
    dlg.showModal();
    document.documentElement.classList.add('body-reels-open');
    history.pushState({ bodyReels: 1 }, '');
    pushed = true;
    current = -1;
    track.style.scrollBehavior = 'auto';
    track.children[i].scrollIntoView();
    track.style.scrollBehavior = '';
    // abre ja tocando com som (o toque no card libera o audio)
    activate(i);
  }
})();
